export const mockLogos = [
  {
    downloadUrl: 'https://afy-book-templates.s3.amazonaws.com/logo/brokerLogoWhite.png',
  },
  {
    downloadUrl: 'https://afy-book-templates.s3.amazonaws.com/logo/brokerLogoBlack.png',
  },
];
